import { getEnv } from '@/env'

export function getAuth0Domain(): string {
  return getEnv('IT_MFE_AUTH0_DOMAIN').trim()
}

export function getAuth0ClientId(): string {
  return getEnv('IT_MFE_AUTH0_CLIENT_ID').trim()
}

export function getAuth0Audience(): string {
  return getEnv('IT_MFE_AUTH0_AUDIENCE').trim()
}

export function getAuth0AuthorizationParams() {
  const audience = getAuth0Audience()
  if (!audience && import.meta.env.DEV) {
    console.warn(
      '[Auth0] IT_MFE_AUTH0_AUDIENCE está vacío. Sin audience, Auth0 no emite un access_token JWT para la API.',
    )
  }
  return {
    redirect_uri: `${window.location.origin}/callback`,
    response_type: 'code' as const,
    scope: 'openid profile email',
    ...(audience ? { audience } : {}),
  }
}

export function getAuth0TokenOptions() {
  const audience = getAuth0Audience()
  return audience ? { authorizationParams: { audience } } : undefined
}
